import { toast as _toast } from 'react-toastify';

const KIND = {
  ERROR: 'error',
  SUCCESS: 'success',
  WARNING: 'warn',
};

const show = (kind, obj) => {

  _toast.dismiss();

  const params = {
    position: 'top-center',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: undefined,
  };

  const text =
    (typeof obj === 'string') ? obj
    : Array.isArray(obj) ? obj
    : JSON.stringify(obj);

  _toast[kind](text + '', params);
};

const contains = (target) => {
  const ancestor = target.closest('.Toastify');
  return ancestor && ancestor.contains(target);
};

const toast = {
  KIND,
  show,
  contains,
};

export default toast;